import { getCountry, getLanguage } from '$lib/helpers/locale-helper';
import { readonly, writable } from 'svelte/store';
import { Environment } from '@squareup/public-web-browser-helpers/environment';
import { getPlanGroupToken } from './plan-group-token';

// indicates the status of the request
// null = not started or loading, true = success, false = error
let ok: boolean | null = null;
// flag to prevent multiple requests
let didInitiateRequest = false;
// private, writable store
const _planGroupPricing = writable<{ ok: boolean | null; plan_group?: any; [key: string]: any }>({ ok });

// public, readonly store
export const planGroupPricing = readonly(_planGroupPricing);

export const PLAN_GROUP_TOKEN_URL_PARAM = 'plan_group_token';

export const setPlanGroupPricing = (locale: string) => {
  if (typeof window === 'undefined') {
    return;
  }
  if (didInitiateRequest) {
    return;
  }
  didInitiateRequest = true;

  async function fetchPlanGroup({ detail }: CustomEvent<Sq.Tracking.CDPUser>) {
    try {
      // set the url
      const planGroupToken = getPlanGroupToken();
      const country = getCountry(locale);
      const language = getLanguage(locale); // In order to simulate locally, you'll need to add `&locale=es-US` in URL.
      const path = `/api/v1/plangroup/${country}/${language}/${planGroupToken}`;
      const url = new URL(path, Environment.api_base_url);

      // see if the merchant is available
      if (detail.entityType === 'merchant' && detail.entityId !== undefined) {
        url.searchParams.set('merchant', detail.entityId);
      }

      // fetch the data
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`${response.status} - ${response.statusText}`);
      }
      const json = await response.json();
      ok = true;
      _planGroupPricing.set({ ...json, ok });
    } catch (error) {
      console.error('Error fetching planGroup,', error);
      ok = false;
      _planGroupPricing.set({ ok });
    }
  }

  // Event listener
  async function listener(detail: CustomEvent<Sq.Tracking.CDPUser>) {
    await fetchPlanGroup(detail);
    window.Sq.Tracking.unsubscribe('sq:cdpTrackerInitialized', listener);
  }

  // Subscribe to Sq.Tracking event
  window.Sq.Tracking.subscribe('sq:cdpTrackerInitialized', listener);
};
